import { useAuthContext } from "../context/AuthContext";
import members from "../data/members";

export function useAuth() {
  const { member, dispatch } = useAuthContext();

  function login(username, password) {
    const found = members.find(
      m => m.username === username && m.password === password
    );

    if (!found) return { success: false, error: "帳號或密碼錯誤" };
    if (found.status === "Baned") return { success: false, error: "此帳號已被停用，請聯絡客服" };
    if (found.status === "Vertifing") return { success: false, error: "帳號審核中，請稍候" };

    dispatch({ type: "LOGIN", member: found });
    return { success: true };
  }

  function logout() {
    dispatch({ type: "LOGOUT" });
  }

  return { member, login, logout, isLoggedIn: member !== null };
}
